import React from 'react';

import { Col, Paper, Row } from 'redpoints-front-components/index';

import ShortenerResolutionFilterByCustomer from './ShortenerResolutionFilterByCustomer';
import ShortenerResolutionFilterDomains from './ShortenerResolutionFilterDomains';
import ShortenerResolutionFiltersActions from './ShortenerResolutionFiltersActions';

const ShortenerResolutionFilters = ({ isEnableFilterByTenant }) => (
  <Paper>
    <Row type="flex">
      <Col lg={8}>
        <ShortenerResolutionFilterByCustomer
          isEnableFilterByTenant={isEnableFilterByTenant}
        />
      </Col>
      <Col lg={6} offset={2}>
        <ShortenerResolutionFilterDomains />
      </Col>
      <Col lg={6} offset={2} align="right">
        <ShortenerResolutionFiltersActions />
      </Col>
    </Row>
  </Paper>
);

export default ShortenerResolutionFilters;
